export default __webpack_public_path__ + "static/media/bg-engage-mobile.c10fbf88.svg";